import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, ReloadPage} from "@insite/client-framework/Store/Context/Handlers/SetLanguage";

replaceInChain(chain, ReloadPage, props => {
    let href = window.location.href;
    const switchingLanguageParameter = "SwitchingLanguage=true";
    /* Poolcorp Custom Code */
    const hasAnchor = href.includes("#");
    if (hasAnchor) {
        href = href.substr(0, window.location.href.indexOf('#'));
    }
    /* Poolcorp Custom Code */
    if (!href.includes(switchingLanguageParameter)) {
        if (window.location.href.indexOf("?") === -1) {
            href += "?";
        } else {
            href += "&";
        }
        href += switchingLanguageParameter;
    }
    window.location.href = href;
});

